import {fx} from "../../../../libs";
import {createEvent, restore, sample} from "effector";
import {Error} from "../../../gateway/edit/types";

export const submitDetachClientFromPartner = createEvent<{ partnerId: number, clientId: number }>()

export const setDetachClientFromPartnerError = createEvent<Error>()

export const detachClientFromPartner = fx<void, void>({
  method: 'POST',
  url: '/partner/{partnerId}/detach/{clientId}',
})

export const $errorDetachClientToPartner = restore(
  setDetachClientFromPartnerError,
  {
    message: '',
    code: 0,
  },
)

sample({
  clock: submitDetachClientFromPartner,
  fn: ({partnerId, clientId}) => {
    return {
      url: `/partner/${partnerId}/detach/${clientId}`
    }
  },
  target: detachClientFromPartner,
})

detachClientFromPartner.done.watch(() => {
  location.reload();
})

sample({
  clock: detachClientFromPartner.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setDetachClientFromPartnerError],
})
